import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { Site, RecurringRevenue, Project, Campaign, WpSite } from '@/lib/types';

export function useDashboard(refresh = false) {
  return useQuery({
    queryKey: ['dashboard', refresh],
    queryFn: () => api.dashboard(refresh),
    staleTime: 30_000,
  });
}

export function useSites() {
  return useQuery({ queryKey: ['sites'], queryFn: api.sites.list });
}

export function useSaveSites() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (sites: Site[]) => api.sites.save(sites),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sites'] }),
  });
}

export function useRecurring() {
  return useQuery({ queryKey: ['recurring'], queryFn: api.recurring.list });
}

export function useSaveRecurring() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (items: RecurringRevenue[]) => api.recurring.save(items),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['recurring'] }),
  });
}

export function useProjects() {
  return useQuery({ queryKey: ['projects'], queryFn: api.projects.list });
}

export function useSaveProjects() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (items: Project[]) => api.projects.save(items),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['projects'] }),
  });
}

export function useMaintenance() {
  return useQuery({ queryKey: ['maintenance'], queryFn: api.maintenance.list });
}

export function useSaveMaintenance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (items: WpSite[]) => api.maintenance.save(items),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['maintenance'] }),
  });
}

export function useCampaigns() {
  return useQuery({ queryKey: ['campaigns'], queryFn: api.campaigns.list });
}

export function useSaveCampaigns() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (items: Campaign[]) => api.campaigns.save(items),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['campaigns'] }),
  });
}

export function useNetwork() {
  return useQuery({ queryKey: ['network'], queryFn: api.network });
}
